
import {MtEventSource} from "./mteventsource";
import {IMtMarkerEvent} from "./imkevent";

export class MtMarker extends MtEventSource<IMtMarkerEvent> {

    private _nativeMarker: google.maps.Marker;
    private _icon: google.maps.Icon;
    private _zIndex: number;
    private _position: google.maps.LatLng;

    constructor(position: google.maps.LatLng, public model?: any, public id?: any) {
        super();

        if (!id) {
            this.id = '' + Math.random();
        }
        this._position = position;
    }

    show(map: google.maps.Map) {
        var self = this;
        this._nativeMarker = new google.maps.Marker({
            position: this._position,
            icon: this._icon,
            zIndex: this._zIndex,
            map
        });
        this._nativeMarker['model'] = this;
        google.maps.event.addListener(this._nativeMarker, "click", function (event) {
            self.event(MtEventSource.EVT_MAP_MARKER_CLICK).emit({source: self, evt: event});
            return true;
        });
    }

    remove() {
        this.removeAllListeners();
        this._nativeMarker.setMap(null);
        this._position = null;
    }

    getId(): any {
        return this.id;
    }

    setZIndex(zi: number): MtMarker {
        if (this._nativeMarker) {
            this._nativeMarker.setZIndex(zi);
        }
        return this;
    }

    getZIndex(): number {
        return this._zIndex;
    }

    getNativeMarker(): google.maps.Marker {
        return this._nativeMarker;
    }

    setIcon(icon: google.maps.Icon): MtMarker {
        this._icon = icon;
        if (this._nativeMarker) {
            this._nativeMarker.setIcon(icon);
        }
        return this;
    }

    setPosition(pos: google.maps.LatLng) {
        this._position = pos;
        if (this._nativeMarker && pos) {
            this._nativeMarker.setPosition(pos);
        }
    }

    setModel(model) {
        this.model = model;
        if (this._nativeMarker) {
            this._nativeMarker['model'] = this;
        }
    }

    getPosition(): google.maps.LatLng {
        return this._position;
    }
}






// WEBPACK FOOTER //
// ./src/mtmarker.ts